import { useFormContext } from 'react-hook-form';
import Stack from '@ui/layout/Stack';
import Text from '@ui/atoms/Text';
import { FormattedMessage } from 'react-intl';
import { ToggleController } from '@ui/atoms/Toggle';

const EpisodeEditFormOptionsExplicitContentField = () => {
    const { control } = useFormContext();

    return (
        <Stack $gap="1rem">
            <Text variant="bodyM" fontWeight="--fw-semibold">
                <FormattedMessage defaultMessage="Contenu explicite" />
            </Text>
            <ToggleController name="options.isExplicit" control={control}>
                <FormattedMessage defaultMessage="Votre épisode contient du contenu explicite (sexe, drogue & rock'n'roll)." />
            </ToggleController>
        </Stack>
    );
};

export default EpisodeEditFormOptionsExplicitContentField;
